import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Avatar from '../Avatar';
import CallAudio from '../CallAudio';
import { IconPhone } from '../Icons';
import Modal from '../Modal';

const IncomingCallModal = ({
  onClickAccept,
  onClickDeny,
  name,
  avatarSrc,
  initials,
  showCloseButton,
  muted,
}) => {
  const { t } = useTranslation('components');

  return (
    <Modal
      showCloseButton={showCloseButton}
      onClickCloseButton={onClickDeny}
      customBackground="bg-slate-600 lg:bg-white"
    >
      <div className="flex flex-col items-center justify-center h-full">
        <CallAudio muted={muted} />
        <Avatar size="32" className="lg:mt-8" alt={name} src={avatarSrc} initials={initials} />
        <div className="mt-8 lg:mt-4 font-semibold text-xl lg:text-base text-white lg:text-slate-900">
          {name} {t('incoming_call')}
        </div>
        <div className="flex mt-16 lg:mt-12 mb-8">
          <button
            type="button"
            onClick={e => {
              e.preventDefault();
              onClickAccept();
            }}
            className="rounded-full flex justify-center items-center p-1 h-16 w-16 mr-8 incomingCallModalAccept focus:outline-none bg-green-500 hover:bg-green-600"
          >
            <IconPhone size="8" className="text-white fill-current" />
          </button>
          <button
            onClick={e => {
              e.preventDefault();
              onClickDeny();
            }}
            type="button"
            className="rounded-full flex justify-center items-center p-1 h-16 w-16 ml-8 focus:outline-none bg-red-600 hover:bg-red-700 rotate-90"
            style={{ transform: 'rotate(135deg)' }}
          >
            <IconPhone size="8" className="text-white fill-current mb-1 ml-1" />
          </button>
        </div>
      </div>
    </Modal>
  );
};

IncomingCallModal.propTypes = {
  name: PropTypes.string,
  initials: PropTypes.string,
  avatarSrc: PropTypes.string,
  onClickDeny: PropTypes.func,
  onClickAccept: PropTypes.func,
  showCloseButton: PropTypes.bool,
  muted: PropTypes.bool,
};

IncomingCallModal.defaultProps = {
  onClickDeny: () => {},
  onClickAccept: () => {},
  showCloseButton: true,
  muted: false,
};

export default IncomingCallModal;
